<template>
  <div class="icon regions-icon">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 160 128"
      style="enable-background: new 0 0 160 128"
      xml:space="preserve"
    >
      <g>
        <path
          class="st0"
          d="M91.9,28c0-6.5-5.3-11.9-11.9-11.9S68.1,21.5,68.1,28S73.5,39.9,80,39.9S91.9,34.5,91.9,28z M74.1,28
		c0-3.2,2.6-5.9,5.9-5.9s5.9,2.6,5.9,5.9s-2.6,5.9-5.9,5.9S74.1,31.2,74.1,28z"
        />
        <path
          class="st0"
          d="M125.7,58.6c-0.5-1-1.5-1.6-2.7-1.6H97.8c5.4-11,10.2-22.5,10.2-29c0-15.4-12.6-28-28-28S52,12.6,52,28
		c0,6.5,4.8,18,10.2,29H37c-1.1,0-2.1,0.6-2.7,1.6l-34,65c-0.5,0.9-0.4,2.1,0.1,2.9C1,127.5,2,128,3,128h154c1.1,0,2-0.6,2.6-1.4
		c0.5-0.9,0.6-2,0.1-2.9C159.7,123.6,125.7,58.6,125.7,58.6z M133.1,85.9c-3.2-0.7-5.5-1.9-6.7-3.6c-0.3-0.5-0.7-1.1-1.1-1.8
		c-1.4-2.4-3.2-5.8-7.3-7.3c-4.4-1.6-8.5,0.1-11.5,1.3c-0.8,0.3-2.1,0.8-2.7,1c-0.4-1.2,0-5.1,1.9-9.2c0.6-1.2,1.2-2.3,2-3.3h13.5
		L133.1,85.9L133.1,85.9z M80,6c12.1,0,22,9.9,22,22c0,9.5-14.1,35.6-22,49.2C72.1,63.6,58,37.5,58,28C58,15.9,67.9,6,80,6z
		 M77.4,84.6C78,85.5,79,86,80,86s2-0.6,2.6-1.4c1.2-2,6.6-11,12.1-21.6h5.9c-0.1,0.2-0.2,0.5-0.4,0.7c-2,4.3-4.7,13.2-0.1,16.7
		c2.7,2.1,5.8,0.8,8.6-0.4c2.4-1,4.9-2,7.2-1.2c2,0.7,3,2.6,4.1,4.6c0.4,0.8,0.9,1.6,1.4,2.4c2.8,3.9,7.7,6.1,15,6.6l11.9,22.8
		c-0.7-0.7-1.4-1.3-2.2-1.9c-1.2-1.1-3.1-0.9-4.2,0.3c-1.1,1.2-0.9,3.2,0.3,4.2c1.6,1.3,3.1,2.8,4.7,4.3H73.3
		c-6.9-8.2-14.8-13.5-23.5-15.9c-4.7-1.3-9.1-1.6-12.7-1.8c-1.5-0.1-3.3-0.2-4.5-0.4c0.8-0.8,2.2-1.9,3-2.7c3.4-2.8,7.2-5.9,6.3-9.9
		c-0.9-3.8-5.3-5.8-14.5-6.5L36,68.5c0.5,1.4,1.1,2.8,1.8,4.2c0.5,1.1,1.6,1.7,2.7,1.7c0.4,0,0.9-0.1,1.3-0.3c1.5-0.7,2.1-2.5,1.4-4
		c-1.1-2.3-2-4.7-2.8-7.1h24.9C70.8,73.6,76.2,82.6,77.4,84.6L77.4,84.6z M24.4,90.6c8.3,0.4,10.9,1.6,11.6,2.1
		c-0.6,1-2.8,2.8-4.1,3.8c-3.4,2.8-6.9,5.6-5.7,9.3c1.1,3.7,5.3,4,10.6,4.4c3.3,0.2,7.4,0.5,11.5,1.6c6.1,1.7,11.7,5.1,16.9,10.1
		H7.9L24.4,90.6L24.4,90.6z"
        />
        <path
          class="st0"
          d="M55.5,93.5c0.5,0.3,1,0.4,1.6,0.4c1,0,2-0.5,2.6-1.4c0.9-1.4,0.4-3.3-1-4.1c-2.6-1.6-5-3.5-7.1-5.8
		c-1.2-1.2-3-1.2-4.2-0.1s-1.2,3-0.1,4.2C49.7,89.3,52.5,91.6,55.5,93.5L55.5,93.5z"
        />
        <path
          class="st0"
          d="M97.9,97c3.1,0.1,6.2,0.5,9.3,1.2c0.2,0.1,0.4,0.1,0.7,0.1c1.4,0,2.6-0.9,2.9-2.3c0.4-1.6-0.7-3.2-2.3-3.6
		c-3.5-0.8-7-1.2-10.4-1.4c-1.7-0.1-3.1,1.2-3.1,2.9C95,95.6,96.3,97,97.9,97L97.9,97z"
        />
        <path
          class="st0"
          d="M72,98.8c0.8,0,1.6,0.1,2.4,0.1c2.9,0,5.7-0.3,8.1-0.6c1.7-0.2,2.8-1.7,2.6-3.3s-1.7-2.8-3.3-2.6
		c-2.8,0.3-6.1,0.7-9.4,0.5c-1.6-0.1-3.1,1.2-3.2,2.8C69.1,97.3,70.3,98.7,72,98.8z"
        />
        <path
          class="st0"
          d="M121.6,103.5c2.8,1.4,5.6,3,8.4,4.8c0.5,0.3,1.1,0.5,1.6,0.5c1,0,1.9-0.5,2.5-1.4c0.9-1.4,0.5-3.2-0.9-4.2
		c-3-1.9-6-3.7-8.9-5.2c-1.5-0.7-3.3-0.1-4,1.3S120.1,102.8,121.6,103.5L121.6,103.5z"
        />
      </g>
    </svg>
  </div>
</template>
